import { ChatBubbleOutline, MedicalServices, People, Event } from "@mui/icons-material";
import { ChatCircleDots, GearSix, SignOut, LockKey } from "phosphor-react";

const Profile_Menu = [
  {
    title: "Change Password",
    icon: <LockKey />,
  },
  {
    title: `Logout`,
    icon: <SignOut />,
  },
];

const Nav_Buttons = [
  {
    index: 0,
    icon: <ChatCircleDots size={24} />,
    title: "Chats",
  },
  {
    index: 1,
    icon: <ChatBubbleOutline size={24} />,
    title: "Templates",
  },
  {
    index: 2,
    icon: <MedicalServices />,
    title: "Services",
  },
  {
    index: 3,
    icon: <People />,
    title: "Stylists",
  },
  {
    index: 4,
    icon: <Event />,
    title: "Appointments",
  },
];

if (process.env.REACT_APP_DEVELOPMENT === '1') {
  Nav_Buttons.push({
    index: 5,
    icon: <ChatCircleDots size={24} />, // Using existing icon for now, or import BugReport
    title: "Test Flow",
  });
}

const Nav_Setting = [
  {
    index: 3,
    icon: <GearSix />,
  },
];

const Message_options = [
  {
    title: "Reply",
  },
  {
    title: "React to message",
  },
  {
    title: "Forward message",
  },
  {
    title: "Star message",
  },
  {
    title: "Report",
  },
  {
    title: "Delete Message",
  },
];

const Languages = ["MARKETING", "UTILITY", "AUTHENTICATION"];
export {
  Profile_Menu,
  Nav_Setting,
  Nav_Buttons,
  Message_options,
  Languages,
};
